import React from "react";
import Icon from "../assets/icon2.png";
import { FaTwitter } from "react-icons/fa";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/footer";
import bg from "../assets/bg.png";
import Farmer from "../components/Farmer";
const Tutorials: React.FC = () => {
  return (
    <div
      className="p-3 bg-fixed bg-center bg-no-repeat	flex flex-col min-h-screen"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <Farmer />
      <Navbar />
      <div className="flex-grow">
        <div className="max-w-faqMax-width flex-grow w-full mx-auto bg-gradient-bg from-opacity-5 to-opacity-0 rounded-2xl p-3 md:p-5 md:px-8 text-white flex flex-col gap-2 mt-2 lg:mt-4">
          <h1 className="text-white text-24 md:text-xl font-bold tracking-tracking1">
            TUTORIALS
          </h1>
          <p className="text-dark_white text-sm">
            Select a chain from below to read our recommendations.
          </p>
          <hr className="max-w-hrMax-width w-full h-px mx-auto border border-transparent_200 my-2" />
          <div className="w-full flex justify-between items-center gap-2 flex-wrap">
            <button className="border border-white border-opacity-10 text-transparent_500 text-sm p-2 rounded-xl w-full sm:w-40 h-11 bg-gradient-bg from-opacity-5 focus:outline-none focus:border focus:border-vibrant_yellow hover:border-vibrant_yellow transition duration-200">
              Base
            </button>
            <button className="border border-white border-opacity-10 text-transparent_500 text-sm p-2 rounded-xl w-full sm:w-40 h-11 bg-gradient-bg from-opacity-5 focus:outline-none focus:border focus:border-vibrant_yellow hover:border-vibrant_yellow transition duration-200">
              zkSync
            </button>
            <button className="border border-white border-opacity-10 text-transparent_500 text-sm p-2 rounded-xl w-full sm:w-40 h-11 bg-gradient-bg from-opacity-5 focus:outline-none focus:border focus:border-vibrant_yellow hover:border-vibrant_yellow transition duration-200">
              Network
            </button>
            <button className="border border-white border-opacity-10 text-transparent_500 text-sm p-2 rounded-xl w-full sm:w-40 h-11 bg-gradient-bg from-opacity-5 focus:outline-none focus:border focus:border-vibrant_yellow hover:border-vibrant_yellow transition duration-200">
              Network
            </button>
            <button className="border border-white border-opacity-10 text-transparent_500 text-sm p-2 rounded-xl w-full sm:w-40 h-11 bg-gradient-bg from-opacity-5 focus:outline-none focus:border focus:border-vibrant_yellow hover:border-vibrant_yellow transition duration-200">
              Network
            </button>
            <button className="border border-white border-opacity-10 text-transparent_500 text-sm p-2 rounded-xl w-full sm:w-40 h-11 bg-gradient-bg from-opacity-5 focus:outline-none focus:border focus:border-vibrant_yellow hover:border-vibrant_yellow transition duration-200">
              Network
            </button>
          </div>
          <div className="flex justify-center gap-2 items-start flex-wrap"></div>
          <div className="flex items-center gap-4">
            <img src={Icon} alt="frame" className="h-11 w-11" />
            <h2 className="font-bold tracking-tracking2 text-2xl">zkSync</h2>
          </div>

          <p className="text-sm font-normal">
            Recommendation for the zkSync Network.
          </p>

          <ul className="text-sm font-normal">
            <li>- min. 10 000 USD Volume</li>
            <li>- min. 100 Transactions</li>
            <li>- min. 10 000 USD Volume</li>
            <li>- min. 100 Transactions</li>
            <li>- min. 10 000 USD Volume</li>
            <li>- min. 100 Transactions</li>
          </ul>

          <p className="text-sm font-normal">Explore some protocols below.</p>

          <ul className="flex items-center gap-7 flex-wrap justify-start mb-6">
            <li className="flex items-center gap-2 text-sm">
              <FaTwitter className="text-xl" /> Name
            </li>
            <li className="flex items-center gap-2 text-sm">
              <FaTwitter className="text-xl" /> Name
            </li>
            <li className="flex items-center gap-2 text-sm">
              <FaTwitter className="text-xl" /> Name
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Tutorials;
